import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { FC } from "react";
import { Option } from "../interface/interface";

interface Props {
  name?: string;
  value: string;
  options: Option[];
  onChange?: (event: SelectChangeEvent<string>) => void;
  onClick?: (event: React.SyntheticEvent) => void;
}

export const DropDown: FC<Props> = ({
  name,
  value,
  options,
  onChange,
  onClick,
}) => {
  return (
    <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
      <InputLabel>{name}</InputLabel>
      <Select value={value} label={name} onChange={onChange} onClick={onClick}>
        {options.map((el) => (
          <MenuItem key={el.value} value={el.value}>
            {el.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
